import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import CloseIcon from '@mui/icons-material/Close';
import StarIcon from '@mui/icons-material/Star';
import StarBorderIcon from '@mui/icons-material/StarBorder';
import IconButton from '@mui/material/IconButton';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';

import { closeActiveThread, favoriteThread, renameThread } from '../../../../actions/aiAnalyticsActions';
import { AI_COLORS } from '../aiAnalyticsConstants';

export default function ChatHeader({ thread }) {
  const dispatch = useDispatch();
  const [editingTitle, setEditingTitle] = useState(false);
  const [titleDraft, setTitleDraft] = useState('');

  function startEditTitle() {
    setTitleDraft(thread.title || '');
    setEditingTitle(true);
  }

  function commitTitle() {
    const trimmed = titleDraft.trim();
    if (trimmed && trimmed !== thread.title) {
      dispatch(renameThread(thread.id, trimmed));
    }
    setEditingTitle(false);
  }

  return (
    <div className="chat-header">
      <IconButton
        size="small"
        onClick={() => dispatch(favoriteThread(thread.id, !thread.favorite))}
        title={thread.favorite ? 'Unfavorite' : 'Favorite'}
      >
        {thread.favorite ? (
          <StarIcon fontSize="small" sx={{ color: AI_COLORS.accent }} />
        ) : (
          <StarBorderIcon fontSize="small" />
        )}
      </IconButton>
      {editingTitle ? (
        <TextField
          size="small"
          autoFocus
          value={titleDraft}
          onChange={e => setTitleDraft(e.target.value)}
          onBlur={commitTitle}
          onKeyDown={e => {
            if (e.key === 'Enter') {
              commitTitle();
            } else if (e.key === 'Escape') {
              setEditingTitle(false);
            }
          }}
          sx={{ flex: 1 }}
        />
      ) : (
        <Typography variant="subtitle1" sx={{ flex: 1, fontWeight: 600, cursor: 'text' }} onClick={startEditTitle}>
          {thread.title || 'New Analysis'}
        </Typography>
      )}
      <IconButton size="small" onClick={() => dispatch(closeActiveThread())} title="Close">
        <CloseIcon fontSize="small" />
      </IconButton>
    </div>
  );
}
